// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"9cdefc0c","597":"98130861","744":"f8fe3463","787":"343d6975","851":"764567fc","914":"e91036b6"}[chunkId] + ".chunk.js";
};